import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, FilePlus } from "lucide-react";

export default function BottomNavBar({ role }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(true);
  const [lastScroll, setLastScroll] = useState(0);

  // Only render for farmers
  if (role !== "farmer") return null;

  const navItems = [
    { id: "home", icon: Home, label: "Home", path: "/farmer/dashboard" },
    { id: "new", icon: FilePlus, label: "New App", path: "/farmer/new-application" },
  ];

  const isActive = (item) => {
    if (!item.path) return false;
    return location.pathname === item.path;
  };

  const handleClick = (item) => {
    if (item.action === "notifications") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      const bellBtn = document.querySelector('[data-testid="notification-bell"]');
      if (bellBtn) bellBtn.click();
      return;
    }
    if (item.path) navigate(item.path);
  };

  return (
    <nav
      data-testid="bottom-nav-bar"
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-stone-200 shadow-[0_-2px_10px_rgba(0,0,0,0.08)] md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="flex items-center justify-around h-14 max-w-lg mx-auto">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item);
          return (
            <button
              key={item.id}
              onClick={() => handleClick(item)}
              data-testid={`bottom-nav-${item.id}`}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                active
                  ? "text-emerald-700"
                  : "text-stone-400 active:text-emerald-600"
              }`}
            >
              <Icon className={`w-5 h-5 ${active ? "stroke-[2.5]" : ""}`} />
              <span className={`text-[10px] mt-0.5 ${active ? "font-semibold" : "font-medium"}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
